import { render } from "./Greedy.vue?vue&type=template&id=6919c3cb&scoped=true"
import script from "./Greedy.vue?vue&type=script&lang=js"
export * from "./Greedy.vue?vue&type=script&lang=js"

import "./Greedy.vue?vue&type=style&index=0&id=6919c3cb&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6919c3cb"]])

export default __exports__